import { useMediaQuery } from 'js/app/hooks/device/hooks/useMediaQuery/useMediaQuery';
import { getVariableCss } from 'js/app/utils/style.util';

const mobileMaxWidth = `(max-width: ${getVariableCss('mobile-max-width')})`;
const tabletMinWidth = `(min-width: ${getVariableCss('tablet-min-width')})`;
const tabletMaxWidth = `(max-width: ${getVariableCss('tablet-max-width')})`;
const desktopMinWidth = `(min-width: ${getVariableCss('desktop-min-width')})`;

export const useInMobile = () => useMediaQuery(mobileMaxWidth);
export const useInTablet = () => useMediaQuery(`${tabletMinWidth} and ${tabletMaxWidth}`);
export const useInMobileAndTablet = () => useMediaQuery(tabletMaxWidth);
export const useInDesktop = () => useMediaQuery(desktopMinWidth);
export const useInTabletAndDesktop = () => useMediaQuery(tabletMinWidth);
